angular.module('app').controller('ListCtrl', function(main, $scope, $http, $rootScope, $mdToast, $mdDialog, $location, appUtils) {
        "ngInject";

    main.query = {
        filter: '',
        limit: 100,
        is_list: true,
        order: '-id',
        page: 1
    };

    main.mapBooleans = function(dict) {
        Object.keys(dict).forEach(function(key) {
            if(dict[key] == 'true') {
                dict[key] = true;
            }
            if(dict[key] == 'false') {
                dict[key] = false;
            }
        });
        return dict;
    }

    angular.extend(main.query, main.mapBooleans($location.search()));

    main.eqFields = [];
    main.searchFields = [];

    main.loading = false;

    main.buildSearch = function(query, searchFields) {
        if(!query) {
            query = main.query;
        }

        if(!searchFields) {
            searchFields = main.searchFields;
        }

        if(!query.filter) {
            return;
        }

        if(searchFields.length > 0) {
            var search = {'or': []};
            searchFields.forEach(function(field) {
                search.or.push({
                    'name': field,
                    'op': 'ilike',
                    'val': '%' + query.filter + '%'
                });
            });
        }

        var number = Number(query.filter);
        if(Math.floor(number) == query.filter) {
            search.or.push({
                'name': 'id',
                'op': 'eq',
                'val': number
            });
        }

        return search;
    };

    main._prepareQuery = function(query, eqFields) {
        if(!query) {
            query = main.query;
        }

        if(!eqFields) {
            eqFields = main.eqFields;
        }
        var params = {
            'is_list': query.is_list,
            'results_per_page': query.limit,
            'page': query.page,
            'q': {
                'filters': []
            }
        };

        var search = main.buildSearch(query);
        if(search) {
            params.q.filters.push(search);
        } else {
            eqFields.forEach(function(field) {
                var val = query[field.localName];
                var op = field.op || 'eq';
                if(val != null && val !== '') {
                    if(field.op == 'search') {
                        op = 'ilike';
                        if(query[field.localName + '_exact'] !== true) {
                            val = '%' + val + '%';
                        } 
                    }
                    params.q.filters.push({
                        'name': field.remoteName,
                        'op': op,
                        'val': val
                    });
                }
            });
        }

        if(query.order) {
            var field = query.order;
            var direction = 'asc';
            if(field[0] == '-') {
                field = field.slice(1);
                direction = 'desc';
            }

            params.q.order_by = [{'field': field, 'direction': direction}];
        }

        return params;
    };

    main.prepareQuery = main._prepareQuery;

    main.download = function(extraParams) {
        var params = main.prepareQuery(main.query);
        if(extraParams) {
            Object.assign(params, extraParams);
        }
        main.loading = $http({'method': 'GET', 'url': '/api/v1/admin/' + main.name + '/download', 'params': params}).then(
            function(response) {
                appUtils.fileReaderDownload('text/csv', main.name + '.csv', response.data);
            }
        );
    };

    main.load = function() {
        var params = main.prepareQuery(main.query);
        main.loading = $http({'method': 'GET', 'url': '/api/v1/admin/' + main.name , 'params': params}).then(
            function(response) {
                main.loading = false;
                main.items = response.data.objects;
                main.total = response.data.num_results;
                $scope.$broadcast('items-loaded');
            }
        );
    };

    main.del = function(item, name) {
        if(!name) {
            name = item.name;
        }
        var confirm = $mdDialog.confirm()
            .title('Delete ' + name + '?')
            .textContent('Are you sure you want to delete ' + name + '?')
            .ariaLabel('Delete confirmation')
            .ok('Delete')
            .cancel('Cancel');

        $mdDialog.show(confirm).then(function() {
            main.loading = $http({'method': 'DELETE', 'url': '/api/v1/admin/' + main.name + '/' + item.id}).then(
                function(response) {
                    appUtils.remove(item, 'id', main.items)
                    main.total = main.total - 1;
                    var alert = $mdToast.simple().textContent("Deleted");
                    $mdToast.show(alert);
                }
            );
        });
    }

    $scope.$evalAsync(main.load);

    $rootScope.$on('loggedIn', main.load);
});

function listCtrlFactory(name) {
    return function($scope, $controller) {
        "ngInject";
        var main = this;

        main.name = name;
        angular.extend(main, $controller('ListCtrl', {'$scope': $scope, 'main': main}));
    };
}
